import { render, staticRenderFns } from "./HowToScheduleTrip.vue?vue&type=template&id=6adea9e4"
import script from "./HowToScheduleTrip.vue?vue&type=script&lang=ts"
export * from "./HowToScheduleTrip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports